import type { Enums } from "../types";

export const ICONS: Enums<"iconName">[] = [
	"arrow-up",
	"arrow-down",
	"arrow-left",
	"arrow-right",
	"arrow-wave-right",
	"arrow-wave-left",
	"arrows-diff",
	"arrows-split",
	"arrows-random",
	"bulb",
	"bolt",
	"folder",
];
